import { z } from 'zod';

import { getFormatMessage } from './validation-errors';

export const useAccountEditValidation = () => {
	const accountEditSchema = z.object({
		email: z.string().email(getFormatMessage()).trim().min(1),
	});

	return { accountEditSchema };
};
export type AccountEditForm = z.infer<ReturnType<typeof useAccountEditValidation>['accountEditSchema']>;
